// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"254":"591a8ce7","362":"591a8ce7","900":"591a8ce7","913":"d11d826b"}[chunkId] + ".chunk.css";
};